function isNotUndefined(val: unknown) {
  return typeof val !== 'undefined';
}

export { isNotUndefined };
